import { Button } from "@mantine/core";
import React from "react";
import { useTranslation } from "react-i18next";
import ConfirmationModal from "../common/ConfirmationModal";
import { deleteOrder } from "../../api";
import { toast } from "react-toastify";
import { LoadingOutlined } from "@ant-design/icons";

/**
 * This Component is Delete Order Button
 * @param orderId this is order id of order which will deleted
 */
const DeleteOrderButton = ({
  orderId,
  onDelete = () => {},
}: {
  orderId: string;
  onDelete?: () => void;
}) => {
  const [modalVisible, setModalVisible] = React.useState<boolean>(false);
  const [isDeleteLoading, setIsDeleteLoading] = React.useState<boolean>(false);

  const { t } = useTranslation();

  const onModalOpen = () => {
    setModalVisible(true);
  };

  const onModalClose = () => {
    setModalVisible(false);
  };

  /**
   * This Method is used to delete order and call parent method onDelete if needed
   */
  const handleDeleteOrder = async () => {
    try {
      setIsDeleteLoading(true);
      if (!orderId) return;
      await deleteOrder({
        id: orderId,
      });
      onDelete();
      toast.success("Order deleted successfully.");
    } catch (error) {
      if (error && (error as Error).message) {
        toast.error((error as Error).message);
      } else {
        toast.error("We are unable to delete order contact admin.");
      }
    } finally {
      setIsDeleteLoading(false);
      onModalClose();
    }
  };

  return (
    <div>
      <Button
        disabled={isDeleteLoading}
        miw={130}
        maw={160}
        color={"red"}
        onClick={() => onModalOpen()}
        rightIcon={isDeleteLoading ? <LoadingOutlined /> : <></>}
      >
        {t("deleteOrder")}
      </Button>
      {modalVisible && (
        <ConfirmationModal
          modalVisible={modalVisible}
          setModalVisible={setModalVisible}
          onDanger={() => onModalClose()}
          onSuccess={() => handleDeleteOrder()}
          title={"deleteOrderTitle"}
        ></ConfirmationModal>
      )}
    </div>
  );
};

export default DeleteOrderButton;
